import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import RollingCounter from "./RollingCounter"; // Import the rolling effect

function ScoreCounter({ score, targetScore }) {
    const { t } = useTranslation();
    const [isTargetReached, setIsTargetReached] = useState(false);
    
    // In challenge mode, you must BEAT the score. 
    // So if the opponent scored 10, the winning score is 11.
    const winningScore = (targetScore !== null && targetScore !== undefined) 
        ? targetScore + 1 
        : null;

    useEffect(() => {
        if (winningScore !== null) {
            // Check if player has reached/beaten the score
            if (score >= winningScore) {
                setIsTargetReached(true);
            } else {
                setIsTargetReached(false);
            }
        } else {
            setIsTargetReached(false);
        }
    }, [score, winningScore]);

    return (
        <div className="stat-box">
            <div className="stat-label">{t('score')}</div>
            {/* stat-value usually defines font-size/color in CSS */}
            <div className={`stat-value ${isTargetReached ? 'score-pulse' : ''}`}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                    
                    {/* The Rolling Counter */}
                    <RollingCounter value={score} />
                    
                    {/* The Target Score (Static) */}
                    {winningScore !== null && (
                        <span className="target-score"> / {winningScore}</span>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ScoreCounter;